import { TemplateRef, Directive, inject } from '@angular/core';

@Directive({
  selector: '[selectOptionLabel]',
  standalone: false,
})
export class SelectOptionLabel {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
